import React from 'react';
import { SizeChartImage, Close } from '../Icons';
import { Title } from './Box/Components.js';
// import Fade from 'react-reveal/Fade';

const SizeChart = (props) => <div className="Product_SizeChart--overlay">
	{/* <Fade big delay={100}> */}
		<div className="Product_SizeChart--modal">
			<span className="modal--exit" onClick={props.handleSizeChart}><strong>Exit</strong> <Close /></span>
			<Title title={'Size Chart'} />
			<SizeChartImage />
		</div>
	{/* </Fade> */}
</div>

export default SizeChart;